import Axios from "axios";
var OrderImportTemplateService = (function () {
    function OrderImportTemplateService() {
    }
    OrderImportTemplateService.prototype.getListPoo = function (params) {
        return Axios.get("supplierclientapi/import_template/list_poo", { params: params });
    };
    OrderImportTemplateService.prototype.getDetail = function (params) {
        return Axios.get("supplierclientapi/import_template/detail", { params: params });
    };
    OrderImportTemplateService.prototype.getInitData = function (params) {
        return Axios.get("supplierclientapi/import_template/get_init_data", { params: params });
    };
    OrderImportTemplateService.prototype.createPoo = function (params) {
        return Axios.post("supplierclientapi/import_template/create_poo", params);
    };
    OrderImportTemplateService.prototype.updatePoo = function (params) {
        return Axios.post("supplierclientapi/import_template/update_poo", params);
    };
    OrderImportTemplateService.prototype.delPoo = function (params) {
        return Axios.get("supplierclientapi/import_template/del_poo", { params: params });
    };
    OrderImportTemplateService.createInstance = function () {
        OrderImportTemplateService.getInstance();
    };
    OrderImportTemplateService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return OrderImportTemplateService;
}());
export default OrderImportTemplateService;
